import firebase from "firebase";
import { uploadFile } from "@/utils/uploader";

export class Dispatcher {
  static async invokeUploadAsync({ payload }) {
    console.log("invokeUploadAsync", payload);

    return new Promise((resolve, reject) => {
      //const current_ref = ref;
      //const current_child = child;
      const fileName = new Date().getTime() + "-" + payload.file.file.name;
      const imageFile = payload.file.file;

      console.log("Im Upload Dispatcher");
      console.log(fileName, imageFile);
      uploadFile(imageFile, {
        auditId: payload.audit_id,
        auditItemId: payload.audititem_id,
        findingId: payload.deviation_id,
        mediaId: payload.media_id
      })
        .then(uploadSnapshot => {
          return uploadSnapshot.ref.getDownloadURL();
        })
        .then(downloadUrl => {
          console.log("download URL");
          console.log(downloadUrl);

          resolve(downloadUrl);
        })
        .catch(error => {
          console.log("Error Uploading File" + error);
          reject(error);
        });
    });
  }

  static async invokeAsyncImport({ ref, child, payload, commit, mutation }) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      const current_ref = ref;
      const current_child = child || null;
      const current_data = payload.data;

      if (current_child) {
        console.log("yes child" + current_child);
        firebase
          .database()
          .ref(current_ref)
          .child(current_child)
          .set(current_data);
      } else {
        console.log("no child" + current_child);
        firebase
          .database()
          .ref(current_ref)
          .set(current_data);
      }
      if (mutation) {
        commit(mutation, { ...payload });
      }
      console.log("Measure Creation sucessful");
      //resolve(firebaseUID);
    });
  }

  static async invokeAsyncDelete({ ref, doc, payload, commit, mutation }) {
    return new Promise((resolve, reject) => {
      const current_ref = ref;
      const current_doc = doc || null;

      console.log("Delete Dispatcher");

      // TODO: Hier werden die gesamten Subcollections gerade nich tmitgelöscht!!!

      firebase
        .firestore()
        .collection(current_ref)
        .doc(current_doc)
        .delete()
        .then(() => {})
        .catch(error => {
          console.log(error);
          reject(error);
        });

      if (mutation) {
        commit(mutation, { ...payload });
      }
      //dispatch("activities/createActivity", activity, { root: true });

      resolve("success"); // pass values
    });
  }

  static async invokeAsyncSet({ ref, doc, child, payload, commit, mutation }) {
    return new Promise((resolve, reject) => {
      const db = firebase.firestore();
      const current_ref = ref;
      const current_doc = doc || null;
      const current_child = child || null;
      const current_data = payload.data;

      console.log("Update DISPATCHER, Doc", current_doc);

      let obj = {};

      if (current_child) {
        obj[current_child] = current_data;
      } else {
        obj = current_data;
      }

      db.collection(current_ref)
        .doc(current_doc)
        .set(obj, { merge: true })
        .then(() => {
          console.log("Firestore-Dispatcher - synchronized");
        })
        .catch(error => {
          console.log("Firestore-Dispatcher - Error");
          console.log(error);
          reject(error);
        });
      if (mutation) {
        commit(mutation, { ...payload });
      }
      resolve("success");
    });
  }

  static async invokeAsyncUpdate({
    ref,
    doc,
    child,
    payload,
    commit,
    mutation
  }) {
    return new Promise((resolve, reject) => {
      const db = firebase.firestore();
      const current_ref = ref;
      const current_doc = doc || null;
      const current_child = child || null;
      const current_data = payload.data;

      console.log("Update DISPATCHER, Doc", current_doc);

      let obj = {};

      if (current_child) {
        obj[current_child] = current_data;
      } else {
        obj = current_data;
      }

      db.collection(current_ref)
        .doc(current_doc)
        .update(obj)
        .then(() => {
          console.log("Firestore-Dispatcher - synchronized");
        })
        .catch(error => {
          console.log("Firestore-Dispatcher - Error");
          console.log(error);
          reject(error);
        });
      if (mutation) {
        commit(mutation, { ...payload });
      }
      resolve("success");
    });
  }

  static async invokeAsyncCreate({ ref, doc, payload, commit, mutation }) {
    return new Promise((resolve, reject) => {
      const db = firebase.firestore();
      const current_ref = ref;
      const current_doc = doc || null;
      const current_data = payload.data;

      let firebasePushRef = null;

      if (current_doc) {
        console.log("Doc:" + current_doc);
        firebasePushRef = db.collection(current_ref).doc(current_doc);
      } else {
        console.log("No Doc:" + current_doc);
        firebasePushRef = db.collection(current_ref).doc();
      }

      const firebaseUID = firebasePushRef.id;

      console.log("FIREBASE UID");
      console.log(firebaseUID);
      console.log(current_data);

      firebasePushRef
        .set(current_data)
        .then(() => {
          console.log("Firestore-Dispatcher sucessful");
        })
        .catch(error => {
          console.log("Firestore-Dispatcher error");
          console.log(error);
          reject(error);
        });

      console.log(firebaseUID);

      if (mutation) {
        commit(mutation, { ...payload, item_id: firebaseUID });
      }

      resolve(firebaseUID);
    });
  }

  static async createAsync({ ref, doc, payload, commit, mutation }) {
    return await Dispatcher.invokeAsyncCreate({
      ref,
      doc,
      payload,
      commit,
      mutation
    });
  }

  static async importAsync({ ref, child, payload, commit, mutation }) {
    return await Dispatcher.invokeAsyncImport({
      ref,
      child,
      payload,
      commit,
      mutation
    });
  }

  static async readAsync({ ref, doc, payload, commit, mutation }) {
    return await Dispatcher.invokeAsyncRead({
      ref,
      doc,
      payload,
      commit,
      mutation
    });
  }

  static async setAsync({ ref, doc, child, payload, commit, mutation }) {
    return await Dispatcher.invokeAsyncSet({
      ref,
      doc,
      child,
      payload,
      commit,
      mutation
    });
  }

  static async updateAsync({ ref, doc, child, payload, commit, mutation }) {
    return await Dispatcher.invokeAsyncUpdate({
      ref,
      doc,
      child,
      payload,
      commit,
      mutation
    });
  }

  static async deleteAsync({ ref, doc, child, payload, commit, mutation }) {
    return await Dispatcher.invokeAsyncDelete({
      ref,
      doc,
      child,
      payload,
      commit,
      mutation
    });
  }

  static async uploadAsync({ ref, child, payload, commit, mutation }) {
    return await Dispatcher.invokeUploadAsync({
      ref,
      child,
      payload,
      commit,
      mutation
    });
  }
}
